import { Endpoint } from '../endpoint';
import {
  CompactProjectTemplateResponse,
  ProjectTemplateId,
  ProjectTemplateResponse,
  ProjectTemplateRequest,
  TemplateStepResponse,
} from '@business/entities/project';

export function fetchProjectTemplates() {
  return Endpoint.get<CompactProjectTemplateResponse[]>('@gc/organizations/project/template');
}

export function fetchProjectTemplate(id: ProjectTemplateId) {
  return Endpoint.get<ProjectTemplateResponse>(`@gc/organizations/project/template/template/${id}`);
}

export function createProjectTemplate(data: ProjectTemplateRequest) {
  return Endpoint.post<ProjectTemplateResponse>(`@gc/organizations/project/template/create`, { data });
}

export function updateProjectTemplate(id: ProjectTemplateId, data: ProjectTemplateRequest) {
  return Endpoint.patch<ProjectTemplateResponse>(`@gc/organizations/project/template/${id}`, { data });
}

export function duplicateProjectTemplate(id: ProjectTemplateId, data: ProjectTemplateRequest) {
  return Endpoint.post<ProjectTemplateResponse>(`@gc/organizations/project/template/duplicate/${id}`, { data });
}

export function deleteProjectTemplate(tempId: ProjectTemplateId) {
  return Endpoint.delete<void>(`@gc/organizations/project/template/${tempId}`);
}

/** Section **/
export function createTemplateSection(id: ProjectTemplateId, name: string, isPublic = false) {
  return Endpoint.post<void>(`@gc/organizations/project/template/section/${id}`, { data: { name, isPublic } });
}

export function updateTemplateSection(id: number, name: string, isPublic = false) {
  return Endpoint.patch<void>(`@gc/organizations/project/template/section/${id}`, { data: { name, isPublic } });
}

export function deleteTemplateSection(id: number) {
  return Endpoint.delete<void>(`@gc/organizations/project/template/section/${id}`);
}

export function sortSections(ids: number[]) {
  return Endpoint.post<void>(`@gc/organizations/project/template/sort-section`, { data: { ids } });
}

/** Step **/
export function fetchStep(id: number) {
  return Endpoint.get<TemplateStepResponse>(`@gc/organizations/project/template/step/${id}`);
}

export function createTemplateStep(id: number, data: Partial<TemplateStepResponse>, parentStepId?: number) {
  data.parentId = parentStepId;
  return Endpoint.post<void>(`@gc/organizations/project/template/step/${id}`, { data });
}

export function updateTemplateStep(id: number, data: Partial<TemplateStepResponse>) {
  return Endpoint.patch<void>(`@gc/organizations/project/template/step/${id}`, { data });
}

export function deleteTemplateStep(id: number) {
  return Endpoint.delete<void>(`@gc/organizations/project/template/step/${id}`);
}

export function sortSectionSteps(ids: number[]) {
  return Endpoint.post<void>(`@gc/organizations/project/template/sort-step`, { data: { ids } });
}
